import { toast } from 'react-hot-toast';

const remove = (id) => toast.remove(id);

export default remove;
